import Request, { API } from '@/http/'
import Vue from 'vue'

function riskTrack (data, result) {
  Request.getData(API.riskTrack, {
    startTime: data.startTime,
    endTime: data.endTime,
    deviceNo: localStorage.getItem('deviceNo'),
    adid: localStorage.getItem('adid'),
    userRandomKey: localStorage.getItem('userRandomKey'),
    longitude: localStorage.getItem('longitude') || null,
    latitude: localStorage.getItem('latitude') || null,
    sceneType: data.sceneType
  })
}

Vue.prototype.$riskTrack = riskTrack
export default {
  riskTrack
}
